import { StyleSheet } from "react-native";
import { RFPercentage } from "react-native-responsive-fontsize";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";

const createStyles = (coresPWA) =>
  StyleSheet.create({
    mainContainer: {
      width: "100%",
      // padding: 5,
      alignItems: "center",
      justifyContent: "center",
      // backgroundColor: 'red',
      // shadowColor: '#000',
      // shadowOffset: {
      //   width: 0,
      //   height: 2,
      // },
      // shadowOpacity: 0.25,
      // shadowRadius: 3.84,
    },

    // button: {
    //   backgroundColor: '#1976d2',
    //   minWidth: wp('25%'), // certifique-se de que wp seja importado
    //   // height: hp('6%'), // certifique-se de que hp seja importado
    //   borderRadius: 5,
    //   justifyContent: 'center',
    //   alignItems: 'center',
    //   flexDirection: 'row',
    //   padding: 11
    // },
    // goBackButton: {
    //   // Se você quiser estilos específicos para o botão 'Voltar', pode adicioná-los aqui
    // },
    // buttonText: {
    //   color: '#fff'
    // }
  });

export default createStyles;
